import {InjectionToken} from '@angular/core'
import {OfferGiftOnlineEmbeddedService} from '@service/offer-gift/offer-gift-online.embedded.service'
import {OfferGiftOnlineService} from '@service/offer-gift/offer-gift-online.service'
import type {EmbeddedClientService} from '@service/embeddingService/embedded-client.service'

/**
 * Factory que resuelve la implementación adecuada de `OfferGiftOnlineService`.
 *
 * @description
 * Devuelve `OfferGiftOnlineEmbeddedService` en modo embebido y
 * `OfferGiftOnlineService` en modo standalone. El servicio gestiona las
 * ofertas y regalos promocionales aplicables en pedidos online.
 *
 * @param embeddedClientService Cliente que detecta si la app corre embebida.
 * @returns Instancia activa de `OfferGiftOnlineService`.
 */
export function providerOfferGiftOnlineFactory(embeddedClientService: EmbeddedClientService) {
  return embeddedClientService.isEmbeddedFunction() ?
      new OfferGiftOnlineEmbeddedService()
    : new OfferGiftOnlineService()
}

/**
 * `InjectionToken` que referencia la instancia activa de `OfferGiftOnlineService`.
 *
 * @description
 * Registrado en `SERVICE_PROVIDERS` junto con
 * {@link providerOfferGiftOnlineFactory}.
 */
export const OfferGiftOnlineServiceToken = new InjectionToken<OfferGiftOnlineService>('OfferGiftService')
